// round-collection.liquid js code start 

document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll('.collection-reveal-fade');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal-active');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  elements.forEach(el => observer.observe(el));
});

// round-collection.liquid js code end 




// ajax-product-render.liquid js code start 

document.addEventListener("click", function (e) {
  if (e.target && e.target.id === "load-more-btn") {
    const grid = document.getElementById("all-tab-product-grid");
    const hiddenCards = grid.querySelectorAll(".snitch-card[style*='display: none']");
    const btn = e.target;

    let counter = 0;
    hiddenCards.forEach(card => {
      if (counter < 10) {
        card.style.display = "block";
        counter++;
      }
    });

    // If no more hidden cards, remove button
    if (grid.querySelectorAll(".snitch-card[style*='display: none']").length === 0) {
      btn.parentElement.style.display = "none";
    }
  }
});

// ajax-product-render.liquid js code end